<template>
  <div id="app">
    <el-row>
      <el-alert v-if="alert.message" :title="alert.message" :type="alert.type" effect="dark"></el-alert>
    </el-row>

    <router-view/>
    
    
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    computed: {
        ...mapState({
            alert: state => state.alert
        }),
    },
    methods: {
      ...mapActions({
          clearAlert: 'alert/clear' 
      }),
    },
    watch: {
        // $route (to, from){
        //     // clear alert on location change
        //     this.clearAlert();
        // }
    } 
  }
</script>

<style lang="less">
  body {
    padding: 0;
    margin: 0;
    height: 100vh;
    background: rgb(238, 241, 246);
    font-family: 'Raleway', sans-serif;
  }
  #app {
    display: flex;
    min-height: 100%;
  }
  aside {
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: rgb(238, 241, 246);
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .el-input__inner::placeholder {
    color: #000;
  }
</style>
